// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"c6786fd0","419":"28e92ed5","563":"2018669f","606":"51e31540","787":"eaeea979"}[chunkId] + ".chunk.js";
};